class CartCache {
  constructor() {
    if (CartCache.instance) {
      return CartCache.instance;
    }

    this.data = null;
    this.timestamp = 0;
    this.ttl = 5000;
    this.isLoading = false;
    this.loadingPromise = null;

    CartCache.instance = this;
  }

  static getInstance() {
    if (!CartCache.instance) {
      new CartCache();
    }
    return CartCache.instance;
  }

  async get(force = false) {
    const now = Date.now();

    if (!force && this.data && (now - this.timestamp) < this.ttl) {
      return this.data;
    }

    if (this.isLoading && this.loadingPromise) {
      return this.loadingPromise;
    }

    this.isLoading = true;
    this.loadingPromise = this.#_fetchCart();

    try {
      let prevData = this.data
      this.data = await this.loadingPromise;
      this.timestamp = now;

      if (JSON.stringify(prevData) !== JSON.stringify(this.data)) {
        document.dispatchEvent(new Event('cart-updated'));
      }

      return this.data;
    } catch (error) {
      this.isLoading = false;
      this.loadingPromise = null;
      throw error;
    } finally {
      this.isLoading = false;
      this.loadingPromise = null;
    }
  }

  async #_fetchCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  }

  invalidate() {
    this.data = null;
    this.timestamp = 0;
    this.isLoading = false;
    this.loadingPromise = null;
  }

  async hasItem(itemId) {
    const cart = await this.get();
    return cart.items.some(item => item.id === itemId);
  }

  // async getFilteredItemCount() {
  //   const cart = await this.get();
  //   const recycleItemId = {{ RECYCLE_ITEM_ID | default: 0 }}; // FIXME
  //
  //   return cart.items.reduce((count, item) => {
  //     return item.id === recycleItemId ? count : count + item.quantity;
  //   }, 0);
  // }

  async getTotalPrice() {
    const cart = await this.get();
    return cart.total_price;
  }

  async refresh() {
    return this.get(true);
  }
}

window.cartCache = CartCache.getInstance();
